import { Component, input, output, signal } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { iconoirNavArrowDown } from '@ng-icons/iconoir';

@Component({
  selector: 'app-accordion',
  imports: [NgIcon],
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  providers: [
    provideIcons({
      iconoirNavArrowDown,
    }),
  ],
})
export class AccordionComponent {
  public title = input.required<string>();
  public disabled = input<boolean>(false);

  public isOpen = signal<boolean>(false);
  public toggled = output<boolean>();

  toggle(): void {
    if (!this.disabled()) {
      const newState = !this.isOpen();
      this.isOpen.set(newState);
      this.toggled.emit(newState);
    }
  }
}
